import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ChooseTopologyItemContainerComponent} from '../../utils/choose-topology-item/choose-topology-item-container/choose-topology-item-container.component';
import * as _ from 'lodash';
import {DateType} from '../../statistics/enums/date-type.enum';
import {DateTimeUnitTypes} from '../../statistics/enums/date-time-unit-types.enum';
import {DashboardApiService} from '../../services/api/dashboard/dashboard-api.service';
import {ChooseTopologyElementFromMapService} from '../../utils/choose-topology-item/services/choose-topology-element-from-map/choose-topology-element-from-map.service';
import {MapSummaryApiService} from '../../network/services/map/map-summary-api/map-summary-api.service';

@Component({
  selector: 'top-routes',
  templateUrl: './top-routes.component.html',
  styleUrls: ['./top-routes.component.scss']
})
export class TopRoutesComponent implements OnInit, OnDestroy {

  @ViewChild(ChooseTopologyItemContainerComponent) topology;

  topRoutesColors = [{
    color: '#AB47BC',
    display: true
  }, {
    color: '#EF5350',
    display: true
  }, {
    color: '#FFA726',
    display: true
  }];
  externalData;
  mapOptions;
  topRoutesObservable;
  topRoutes: any = [];

  constructor(private chooseTopologyElementsFromMapService: ChooseTopologyElementFromMapService,
              private dashboardApiService: DashboardApiService,
              private mapSummaryApi: MapSummaryApiService) {
  }

  ngOnInit(): void {
    this.initializeTopologyMap();
  }

  onMapClick($event: any): void {

  }

  onTopologyReady(): void {
    this.fetchTopRoutes(this.externalData.nodes, this.externalData.pCons);
  }

  initializeTopologyMap(): void {
    this.dashboardApiService.externalData().then(data => {
      this.externalData = _.cloneDeep(data);
      this.prepareNetworkElements();
      this.mapOptions = this.chooseTopologyElementsFromMapService.prepareOptionsForDashboard(
        this.externalData.nodes, this.externalData.pCons, 'dashboard');
    });
  }

  private prepareNetworkElements(): void {
    let index = 1;

    this.externalData.voipPeers.forEach(voipPeer => {
      voipPeer.elementType = 'Online VoIP Peer';
      index++;
    });

    this.externalData.nodes.forEach(node => {
      node.elementType = 'Online Node';
      index++;
    });

    this.externalData.pCons.forEach(pcon => {
      pcon.elementType = 'Online Peer Connection';
      pcon.name = pcon.name + ' (' + pcon.nodeName + ')';
      index++;
    });
  }

  private fetchTopRoutes(nodes, pCons): void {
    this.topRoutesObservable = this.mapSummaryApi.getTopRoutes((topRoutes) => {
      this.topRoutes = topRoutes;
      this.updateTopologyMap();
    }, {dateType: DateType.RELATIVE, relativeTimeUnit: DateTimeUnitTypes.HOUR, relativeTimeUnitValue: 3, maxRoutes: 3},
      {elements: pCons}, nodes);
  }

  private preparePathForDraw(topRoutePath, color): any {
    const path = {nodes: [], edges: [], color};

    path.edges = this.prepareEdgesToDraw(topRoutePath);
    path.nodes = this.prepareNodesToDraw(topRoutePath);

    return [path];
  }

  private prepareNodesToDraw(topRoutePath): any {
    const nodes = [];

    nodes.push('node_' + topRoutePath.srcNode);

    if (topRoutePath.edges !== null) {
      topRoutePath.edges.forEach((edge) => {
        nodes.push('node_' + edge.connDestNode);
      });
    }

    if (topRoutePath.destNode !== null && nodes.indexOf('node_' + topRoutePath.destNode) === -1) {
      nodes.push('node_' + topRoutePath.destNode);
    }

    return nodes;
  }

  private prepareEdgesToDraw(topRoutePath): any {
    const edges = [];

    edges.push('peerConnection_' + topRoutePath.srcPeerConnection);

    if (topRoutePath.edges !== null) {
      topRoutePath.edges.forEach((edge) => {
        edges.push('connection_' + edge.connectionId);
      });
    }

    if (topRoutePath.srcPeerConnection !== topRoutePath.destPeerConnection) {
      edges.push('peerConnection_' + topRoutePath.destPeerConnection);
    }
    return edges;
  }

  ngOnDestroy(): void {
    if (this.topRoutesObservable) {
      this.topRoutesObservable.unsubscribe();
    }
  }

  updateTopologyMap(): void {
    const routes = [];
    const topRoutesColors = [...this.topRoutesColors];
    this.topRoutes.routes.forEach((route, index) => {
      if (topRoutesColors[index].display) {
        routes.push(...this.preparePathForDraw(route, topRoutesColors[index].color));
      }
    });

    this.topology.drawPath(routes);
  }

  getRouteColor(route): string {
    return (route.display ? route.color : '#cccccc');
  }
}
